import request from "@/utils/request";
import qs from "qs";

export function getCoupon(param) {
    return request({
        url: '/admin/coupon/search-coupon',
        method: 'GET',
        params: param
    })
}

export function saveCoupon(data, id) {
    if (id) {
        return request({
            url: 'admin/coupon/' + id,
            method: 'PUT',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data)
        })
    } else {
        return request({
            url: 'admin/coupon',
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data)
        })
    }
}

export function deleteCoupon(id) {
    return request({
        url: '/admin/coupon/' + id,
        method: 'DELETE'
    })
}

export function getCouponRole(id) {
    return request({
        url: '/admin/manager/' + id + '/coupon-role',
        method: 'GET'
    })
}

export function saveCouponRole(data) {
    return request({
        url: '/admin/manager/coupon-role',
        method: 'PUT',
        params: data
    })
}
export function getCouponLog(param) {
    return request({
        url: '/admin/search-coupon-log',
        method: 'GET',
        params: param
    })
}

export function getCouponRecord(param) {
    return request({
        url: '/admin/coupon/search-use-coupon',
        method: 'GET',
        params: param
    })
}

export function getCouponUsers(param) {
    return request({
        url: 'admin/coupon/getAdminCouponUserList',
        method: 'GET',
        params: param
    })
}

export function deleteUserCoupon(data) {
    return request({
        url: 'admin/coupon/deleteAdminUserCoupon',
        method: 'DELETE',
        data
    })
}

// 商城优惠券
export function getStoreCoupon(param) {
    return request({
        url: '/admin/productCoupon/getProductCouponList',
        method: 'GET',
        params: param
    })
}
export function createStoreCoupon(data) {
    return request({
        url: '/admin/productCoupon/createProductCoupon',
        method: 'POST',
        data
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        // data: qs.stringify(data)
    })
}

export function saveStoreCoupon(data) {
    return request({
        url: '/admin/productCoupon/updateProductCoupon',
        method: 'PUT',
        data
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        // data: qs.stringify(data)
    })
}

export function deleteStoreCoupon(data) {
    return request({
        url: '/admin/productCoupon/deleteProductCoupon',
        method: 'DELETE',
        data
    })
}
